











import { Component, Vue } from "vue-property-decorator";

import SignupCard from "@/components/Account/SignupCard.vue";

@Component({
  components: {
    SignupCard
  }
})
export default class SignUp extends Vue {}
